function initPriceFilter() {

  const checkboxes = document.querySelectorAll(".price-filter input");

  if (!checkboxes.length) return;

  checkboxes.forEach(cb => {
    cb.removeEventListener("change", applyPriceFilter);
    cb.addEventListener("change", applyPriceFilter);
  });

}

function applyPriceFilter() {

  const activeRanges = [];

  document.querySelectorAll(".price-filter input").forEach(cb => {
    if (cb.checked) {
      activeRanges.push(cb.dataset.range);
    }
  });

  const products = document.querySelectorAll("[data-product-grid]");

  console.log("Filter läuft. Produkte:", products.length);

  products.forEach(product => {

    const price = parseFloat(product.dataset.price);

    if (!price) return;

    if (activeRanges.length === 0) {
      product.style.display = "";
      return;
    }

    const match = activeRanges.some(range => {
      const [min, max] = range.split("-").map(Number);
      return price >= min && price <= max;
    });

    product.style.display = match ? "" : "none";

  });

}

document.addEventListener("DOMContentLoaded", initPriceFilter);